import React from 'react';
import { Link } from 'react-router-dom';
import { products, companyInfo } from '../data/mock';
import { GateMark } from './PcbHeader';
import './landing.css';

const PcbFooter = () => (
  <footer className="relative border-t px-6 py-12" style={{ borderColor: 'var(--pcb-line)' }} role="contentinfo">
    <span className="pcb-hole" style={{ top: '0.875rem', left: '0.875rem' }} aria-hidden="true" />
    <span className="pcb-hole" style={{ top: '0.875rem', right: '0.875rem' }} aria-hidden="true" />
    <span className="pcb-hole" style={{ bottom: '0.875rem', left: '0.875rem' }} aria-hidden="true" />
    <span className="pcb-hole" style={{ bottom: '0.875rem', right: '0.875rem' }} aria-hidden="true" />

    <div className="container mx-auto max-w-6xl">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-3">
            <GateMark />
            <span className="pcb-mono font-semibold text-lg">{companyInfo.name}</span>
          </div>
          <p className="text-sm leading-relaxed" style={{ color: 'var(--pcb-silk-dim)' }}>
            Hands-on boards that make digital logic visible. Designed, assembled, and shipped
            from Estonia by Oliver. Founded {companyInfo.foundedYear}.
          </p>
        </div>

        <nav aria-label="Product links">
          <h3 className="pcb-mono text-xs uppercase tracking-widest mb-4" style={{ color: 'var(--pcb-silk-dim)' }}>
            Products
          </h3>
          <ul className="space-y-2">
            {products.map((product) => (
              <li key={product.id}>
                <Link
                  to={`/product/${product.id}`}
                  onClick={() => window.scrollTo(0, 0)}
                  className="pcb-nav-link normal-case tracking-normal text-sm"
                >
                  {product.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Site links">
          <h3 className="pcb-mono text-xs uppercase tracking-widest mb-4" style={{ color: 'var(--pcb-silk-dim)' }}>
            Site
          </h3>
          <ul className="space-y-2">
            <li>
              <Link
                to="/logic-wiki"
                onClick={() => window.scrollTo(0, 0)}
                className="pcb-nav-link normal-case tracking-normal text-sm"
              >
                Logic Wiki
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                onClick={() => window.scrollTo(0, 0)}
                className="pcb-nav-link normal-case tracking-normal text-sm"
              >
                About
              </Link>
            </li>
            <li>
              <Link to="/#contact" className="pcb-nav-link normal-case tracking-normal text-sm">Contact</Link>
            </li>
            <li>
              <button type="button" className="marketing-settings pcb-nav-link normal-case tracking-normal text-sm"
                aria-haspopup="false" onClick={() => window.dispatchEvent(new Event('open-marketing-privacy'))}>
                Marketing privacy
              </button>
            </li>
            <li>
              <a href={`https://${companyInfo.website}`} className="pcb-nav-link normal-case tracking-normal text-sm">
                {companyInfo.website}
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <p
        className="pcb-mono text-xs mt-10 pt-6 border-t text-center"
        style={{ color: 'var(--pcb-silk-dim)', borderColor: 'var(--pcb-line)' }}
      >
        &copy; {new Date().getFullYear()} {companyInfo.name} &middot; All rights reserved
      </p>
    </div>
  </footer>
);

export default PcbFooter;
